import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import { apiPaths } from 'app/services/api';
import useAuth from 'app/hooks/useAuth';

const roleFields = {
  finance: {},
};

const Warranties = () => {
  const { user } = useAuth();
  const roles = user.roles;
  const showLimited = user.roles.includes('insurance_manager');
  const columns = [
    { name: 'Serial Number', key: 'warranty_number' },
    { name: 'Brand', key: 'brand' },
    { name: 'Model', key: 'model', width: '150' },
    { name: 'IMEI', key: 'imei', width: '150' },

    { name: 'Product Price', key: 'product_price', type: 'price' },
    { name: 'Warranty Price', key: 'warranty_price', type: 'price' },
    { name: 'Vat', key: 'vat_price', type: 'price' },

    { name: 'Store', key: 'store_name' },
    { name: 'Seller', key: 'seller_name' },
    { name: 'Store Commission', key: 'store_commission', type: 'price', width: '110' },

    { name: 'Customer', key: 'customer_name' },
    { name: 'Insurance', key: 'insurance_name' },

    { name: 'Pay Date', key: 'paid_at', type: 'date', sort: true },
  ];
  const limitedCols = [
    // { name: 'Serial Number', key: 'warranty_number' },
    // { name: 'Insurance', key: 'insurance_name' },
    { name: 'Brand', key: 'brand' },
    { name: 'Model', key: 'model' },
    { name: 'IMEI', key: 'imei' },
    { name: 'Pay Date', key: 'paid_at', type: 'date', sort: true },
    { name: 'Expire Date', key: 'expires_at', type: 'date', sort: true },
  ];

  const filtersOn = [
    { name: 'Date From', key: 'paid_at_min', type: 'date' },
    { name: 'Date To', key: 'paid_at_max', type: 'date' },
    { name: 'Customer Name', key: 'customer_name' },
    { name: 'Customer National Id', key: 'customer_national_id' },
    { name: 'Customer Mobile', key: 'customer_mobile_number' },
    { name: 'IMEI', key: 'imei' },
    {
      name: 'Store',
      key: 'store_uuid_exact',
      type: 'auto_complete',
      options: { entity: 'stores', path: apiPaths.STORES },
      auth: ['admin'],
      // show: { key: 'type', value: 'organisational' },
    },
    { name: 'Serial Number', key: 'warranty_number' },
    // {
    //   name: 'Insurance',
    //   key: 'insurance_uuid_exact',
    //   type: 'auto_complete',
    //   options: { entity: 'insurances', path: apiPaths.INSURANCES },
    //   auth: ['admin'],
    //   // show: { key: 'type', value: 'organisational' },
    // },
    // {
    //   name: 'Seller',
    //   key: 'seller_uuid_exact',
    //   type: 'auto_complete',
    //   options: { entity: 'sellers', path: apiPaths.SELLERS },
    //   auth: ['admin']
    //   // show: { key: 'type', value: 'organisational' },
    // }
  ];
  const limitedFilters = [
    { name: 'Date From', key: 'created_at_min', type: 'date' },
    { name: 'Date To', key: 'created_at_max', type: 'date' },
    { name: 'IMEI', key: 'imei' },
  ];

  return (
    <div className="m-sm-30">
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Warranties"
          path="warranties"
          defaultSort="paid_at"
          apipath={apiPaths.WARRANTIES}
          defaultFilter={{ paid_bool: true }}
          columns={showLimited ? limitedCols : columns}
          filtersOn={showLimited ? limitedFilters : filtersOn}
          hideActions={['create', 'delete']}
          actions={[
            {
              key: 'edit',
              auth: ['admin'],
            },
          ]}
          showExport
        />
      </SimpleCard>
    </div>
  );
};

export default Warranties;
